<template>
  <ElDialog
    :title="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHANGE_DAILY_CAP')"
    :visible="value"
    width="25%"
    @open="initializeModel"
    @close="close"
  >
    <ElForm
      ref="campaignDailyCapForm"
      :model="campaignDailyCapModel"
      :rules="campaignDailyCapRules"
      label-position="top"
      @submit.native.prevent="changeDailyCap"
    >
      <ElFormItem
        :label="$t('ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_AMOUNT')"
        prop="dailyCap"
      >
        <ElInput
          v-model.number="campaignDailyCapModel.dailyCap"
          :disabled="isLoading"
          maxlength="11"
        />
      </ElFormItem>
      <p v-if="campaignDailyCapModel.dailyCap">
        <strong>
          {{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_AMOUNT') }}:
        </strong>
        {{ currencyFormat(campaignDailyCapModel.dailyCap) }} {{ $t('RIALS') }}
        <br />
      </p>
      <p v-else>
        {{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.WITHOUT_DAILY_CAP') }}
      </p>

      <!-- dirty hack until ElementUI ends up with a solution -->
      <input v-show="false" type="submit" />
    </ElForm>
    <div slot="footer" class="dialog-footer">
      <ElButton
        type="primary"
        :loading="isLoading"
        @click.native.prevent="changeDailyCap"
      >
        {{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHANGE_DAILY_CAP') }}
      </ElButton>
      <ElButton type="text" :plain="true" @click.native.prevent="close">
        {{ $t('CANCEL') }}
      </ElButton>
    </div>
  </ElDialog>
</template>

<script>
import { format as currencyFormat } from '@/utils/number';

import form from '@/mixins/form';
import { AdCampaignFinance } from '@/api/api';
import campaignId from '@/mixins/advertisement/campaignId';

export default {
  name: 'EditCampaignDailyCapModal',
  mixins: [form, campaignId],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    defaultDailyCap: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      campaignDailyCapModel: {
        dailyCap: this.defaultDailyCap,
      },
      isLoading: false,
    };
  },
  computed: {
    campaignDailyCapRules() {
      return {
        dailyCap: [
          {
            required: true,
            message: this.$t('ADVERTISEMENT.CAMPAIGN_FINANCE.CHANGE_DAILY_CAP'),
            trigger: 'blur',
            type: 'number',
          },
          {
            validator: this.validateDailyCap,
            trigger: 'blue',
          },
        ],
      };
    },
  },
  methods: {
    currencyFormat,

    validateDailyCap(rule, value, cb) {
      const {
        campaignDailyCapModel: { dailyCap },
      } = this;
      if (dailyCap !== 0 && dailyCap < 1000000) {
        cb(
          new Error(this.$t('ADVERTISEMENT.CAMPAIGN_FINANCE.DAILY_CAP_ERROR')),
        );
        return;
      }
      cb();
    },
    initializeModel() {
      this.campaignDailyCapModel.dailyCap = this.defaultDailyCap;
    },
    close() {
      this.$emit('input', false);
    },
    changeDailyCap() {
      if (!this.isValid('campaignDailyCapForm')) {
        return false;
      }

      this.isLoading = true;

      const dailyCap = this.campaignDailyCapModel.dailyCap || null;

      return AdCampaignFinance.changeCampaignDailyCap(
        {
          itemId: this.campaignId,
        },
        {
          daily_cap: dailyCap,
        },
      )
        .then(({ body: { message } }) => {
          if (message) {
            this.$message.success(message);
          }
          this.$emit('changed');
          this.close();
        })
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
